"use client"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { MailCheck, Send } from "lucide-react"
import { useState } from "react"

export function TestTemplateModal({ testEmail, setTestEmail, sendTestEmail, content }: any) {
    const [loading, setLoading] = useState<boolean>(false)
    const handleSendTestEmail = async () => {
        if (!testEmail) return
        try {
            setLoading(true)
            await sendTestEmail({
                testEmail: testEmail,
                subject: "Test Template",
                displayName: "Test Template",
                template: content
            });

        } catch (error) {
            console.log(error)
        } finally {
            setTestEmail("")
            setLoading(false)
        }
    };

  return (
    <Dialog >
      <DialogTrigger asChild className="flex items-center justify-center w-full">
        <Button
          variant="outline"
          size="sm"
          className="gap-1"
          title="Test Template"
        >
          <MailCheck className="h-4 w-4" />
          Test
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-md bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800">
        <DialogHeader className="space-y-2">
          <DialogTitle className="flex items-center gap-2 text-gray-900 dark:text-gray-100">
            <MailCheck className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            Send Test Email
          </DialogTitle>
          <DialogDescription className="text-gray-500 dark:text-gray-400">
            Enter an email address to preview how this template will look when delivered.
          </DialogDescription>
        </DialogHeader>

        {/* Input Section */}
        <div className="space-y-3 mt-4">
          <Label className="text-sm text-gray-700 dark:text-gray-300">
            Test Email Address
          </Label>

          <Input
            placeholder="example@email.com"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault()
                handleSendTestEmail()
              }
            }}
            className="bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 focus-visible:ring-2 focus-visible:ring-blue-500"
          />
        </div>

        {/* Footer */}
        <DialogFooter className="mt-6 gap-2">
          <DialogClose asChild>
            <Button
              variant="outline"
              className="border-gray-200 dark:border-gray-700"
            >
              Cancel
            </Button>
          </DialogClose>

          <Button
            type="button"
            onClick={handleSendTestEmail}
            className="gap-2"
          >
            <Send className="h-4 w-4" />
           { loading ? "Sending..." : "Send Test Email"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
